export default "/images/vendor/flag-icon-css/flags/1x1/cu.svg?212ed2a57a9492cf43375411e50f056c";